import type { ReactNode } from 'react';
import { Card } from '../../components/ui/card';
import { cn } from '../utils';
import { notFoundStripeColors } from './stripe-colors';
import { useNoiseEasterEgg } from './useNoiseEasterEgg';

interface NotFoundPageProps {
  title: string;
  message: ReactNode;
  actions: ReactNode;
  className?: string;
}

function NotFoundPage({ title, message, actions, className }: NotFoundPageProps) {
  const noise = useNoiseEasterEgg();

  return (
    <div className={cn('relative flex flex-1 items-center justify-center overflow-hidden', className)}>
      <div className="absolute inset-0 flex" aria-hidden="true">
        {notFoundStripeColors.map((color) => (
          <div key={color} className="flex-1" style={{ backgroundColor: color }} />
        ))}
      </div>

      {noise.active ? (
        <div
          className="pointer-events-none absolute -inset-[100px] z-10 animate-tv-static opacity-35 [will-change:transform]"
          style={{
            backgroundImage: `url(${noise.url})`,
            backgroundRepeat: 'repeat',
          }}
          aria-hidden="true"
        />
      ) : null}

      <Card className="relative z-20 mx-4 flex w-full max-w-content-md flex-col items-center gap-3 p-8 text-center shadow-popover">
        <h1 className="font-headline font-semibold text-2xl">{title}</h1>
        <p className="font-light text-muted-foreground text-sm">{message}</p>
        <div className="mt-2 flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:flex-wrap sm:justify-center [&>*]:w-full sm:[&>*]:w-auto">
          {actions}
        </div>
      </Card>
    </div>
  );
}

export type { NotFoundPageProps };
export { NotFoundPage };
